export const AUTHENTICATE = 'Authenticate';
export const REAUTHENTICATE = 'Refresh';
export const DEAUTHENTICATE = 'Deauthenticate';
export const PERMISSIONS = 'Permission';
export const GROUPS = 'Groups';
export const FORGOT = 'forgotPassword';

export const VERIFY = 'verify';
